document.addEventListener("DOMContentLoaded", function () {
  let isOpen = false;
  const menuTrigger = document.querySelector(".js-show-mobile-menu");
  const menu = document.querySelector(".mobile-menu");
  const menuClose = document.querySelector(".mobile-menu__close");
  const shadow = document.querySelector(".fullpage-shadow");
  const sections = menu.querySelectorAll(".mobile-menu__section");
  const links = menu.querySelectorAll(".mobile-menu__link");

  const close = () => {
    menu.classList.remove("open");
    shadow.classList.remove("open");
    setTimeout(() => {
      setActiveSection("main");
    }, 300);
    isOpen = false;
  };

  const open = () => {
    menu.classList.add("open");
    shadow.classList.add("open");
    setActiveSection("main");
    isOpen = true;
  };

  document.addEventListener("keyup", (event) => {
    if (isOpen && event.key === "Escape") {
      close();
    }
  });

  window.addEventListener("click", (event) => {
    if (
      isOpen &&
      !event.target.closest(".mobile-menu") &&
      !event.target.closest(".js-show-mobile-menu")
    ) {
      close();
    }
  });

  const setActiveSection = (target) => {
    sections.forEach((section) => {
      section.classList.remove("visible");
    });

    setTimeout(() => {
      sections.forEach((section) => {
        section.classList.remove("active");
      });
      const activeSection = menu.querySelector(`[data-section="${target}"]`);
      activeSection.classList.add("active");
      activeSection.classList.add("visible");
    }, 300);
  };

  menuTrigger.addEventListener("click", function () {
    open();
  });

  menuClose.addEventListener("click", function () {
    close();
  });

  links.forEach(function (link) {
    link.addEventListener("click", function () {
      setActiveSection(link.dataset.target);
    });
  });
});
